var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _path33, _path34, _path35, _path36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 137.5L214 183L59 92.5L140 45L300 137.5Z",
    fill: "#E5F7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226 206H112.5H-1V71.5L226 206Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 132.9C225.658 132.9 227.418 132.188 227.418 131.309C227.418 130.431 225.658 129.719 223.488 129.719C221.317 129.719 219.558 130.431 219.558 131.309C219.558 132.188 221.317 132.9 223.488 132.9Z",
    fill: "#192643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.85 111.004C229.85 116.65 226.17 121.453 223.394 121.453C220.618 121.453 217 117.086 217 111.441C217 105.796 220.618 97 223.394 97C226.17 97 229.85 105.359 229.85 111.004Z",
    fill: "#192643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 102.614V131.465",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 107.885L223.487 112.844",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 104.143L223.425 109.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 111.129L223.425 116.12",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 114.436L223.487 119.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M222.24 131.153C222.24 131.153 223.675 131.902 224.735 131.153",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 93.9002C146.658 93.9002 148.418 93.188 148.418 92.3095C148.418 91.4309 146.658 90.7188 144.488 90.7188C142.317 90.7188 140.558 91.4309 140.558 92.3095C140.558 93.188 142.317 93.9002 144.488 93.9002Z",
    fill: "#192643"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.85 72.0044C150.85 77.6498 147.17 82.4531 144.394 82.4531C141.618 82.4531 138 78.0865 138 72.4411C138 66.7956 141.618 58 144.394 58C147.17 58 150.85 66.359 150.85 72.0044Z",
    fill: "#192643"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 63.6143V92.4652",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 68.8853L144.487 73.8445",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 65.1426L144.425 70.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 72.1294L144.425 77.1198",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 75.4355L144.487 80.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 92.1533C143.24 92.1533 144.675 92.9019 145.735 92.1533",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.065 119.688C209.314 119.688 206.273 118.458 206.273 116.939C206.273 115.421 209.314 114.19 213.065 114.19C216.815 114.19 219.856 115.421 219.856 116.939C219.856 118.458 216.815 119.688 213.065 119.688Z",
    fill: "#192643"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.216 116.674C215.216 116.674 212.737 117.968 210.904 116.674",
    stroke: "#00B0A6",
    strokeWidth: 2.081,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 136.237V111.119L206 97.7646L191.501 122.882V153L220.5 136.237Z",
    fill: "#00B0A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.499 122.881L205.998 97.763L154.5 68L140 93L191.499 122.881Z",
    fill: "#192643"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 122.885L140 92.8823V123L191.505 153.003V122.885Z",
    fill: "#018289"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 126.215V145.565L211.067 141.684V122.334L204.384 126.215Z",
    fill: "#192643"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 126.208L173.28 122.328V133.916L179.964 137.797V126.208Z",
    fill: "#192643"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 145.564L211.067 141.684L204.384 137.372V145.564Z",
    fill: "#101627"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 137.797L173.28 133.917L179.964 129.604V137.797Z",
    fill: "#101627"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 111.208L148.28 107.328V118.916L154.964 122.797V111.208Z",
    fill: "#192643"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 122.797L148.28 118.917L154.964 114.604V122.797Z",
    fill: "#101627"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.5 36L48.5 83L-0.5 53.5V3H63.5L129.5 36Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.333 57.3055C304.333 75.231 289.801 89.7638 271.875 89.7638C253.95 89.7638 239.417 75.231 239.417 57.3055C239.417 39.38 253.95 24.8472 271.875 24.8472C289.801 24.8472 304.333 39.38 304.333 57.3055Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M300.917 54.4583C300.917 72.3839 286.384 86.9167 268.458 86.9167C250.533 86.9167 236 72.3839 236 54.4583C236 36.5328 250.533 22 268.458 22C286.384 22 300.917 36.5328 300.917 54.4583Z",
    fill: "#152954"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178 58L178 83",
    stroke: "#192643",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M238 58L177 58",
    stroke: "#192643",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271.5,
    cy: 55.5,
    r: 16.5,
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M269 27C254.089 27 242 39.0888 242 54C242 68.9112 254.089 81 269 81C283.911 81 296 68.9112 296 54C296 39.0888 283.911 27 269 27ZM292.069 50.0616L288.517 50.6592C288.337 49.5918 288.066 48.528 287.707 47.4966L291.108 46.3158C291.532 47.5344 291.855 48.7944 292.069 50.0616ZM289.54 42.7824L286.383 44.5122C285.861 43.5582 285.254 42.6402 284.583 41.7834L287.412 39.5622C288.208 40.5702 288.922 41.6556 289.54 42.7824ZM270.859 30.6738L270.571 34.263C269.488 34.1748 268.381 34.1838 267.299 34.2702L267 30.6864C268.273 30.5766 269.589 30.5712 270.859 30.6738ZM263.188 31.3272L264.077 34.8156C263.026 35.0838 261.989 35.4438 260.994 35.8848L259.534 32.5944C260.713 32.0706 261.942 31.6476 263.188 31.3272ZM256.148 34.4448L258.126 37.4508C257.219 38.0484 256.355 38.727 255.554 39.4686L253.108 36.8226C254.055 35.9496 255.079 35.1468 256.148 34.4448ZM250.496 39.6702L253.347 41.8734C252.674 42.7428 252.073 43.6662 251.56 44.6184L248.392 42.9066C248.998 41.7852 249.706 40.6962 250.496 39.6702ZM246.846 46.4544L250.251 47.6154C249.902 48.6468 249.636 49.7124 249.463 50.7816L245.908 50.2056C246.115 48.9366 246.43 47.6748 246.846 46.4544ZM245.6 54.0486L249.2 54.0378C249.204 55.1322 249.295 56.232 249.474 57.3012L245.922 57.8952C245.713 56.6334 245.604 55.3392 245.6 54.0486ZM248.435 65.1726C247.816 64.0404 247.292 62.8488 246.873 61.6392L250.278 60.4656C250.631 61.488 251.074 62.4942 251.594 63.45L248.435 65.1726ZM253.176 71.2368C252.224 70.362 251.342 69.408 250.557 68.4L253.394 66.186C254.058 67.0374 254.805 67.8456 255.612 68.5872L253.176 71.2368ZM259.624 75.4452C258.443 74.9286 257.296 74.3094 256.222 73.6074L258.196 70.5942C259.1 71.1882 260.068 71.7102 261.067 72.1476L259.624 75.4452ZM267.097 77.3226C265.81 77.22 264.527 77.0094 263.285 76.6962L264.163 73.206C265.213 73.4688 266.296 73.6452 267.385 73.7352L267.097 77.3226ZM267.2 66.6V48.0798L261.8 49.7844V45.2844L272.101 41.4H272.6V66.6H267.2ZM270.951 77.3226L270.652 73.7352C271.74 73.6434 272.825 73.4634 273.88 73.1952L274.762 76.6854C273.518 77.0004 272.235 77.2146 270.951 77.3226ZM273.799 34.785L274.666 31.2912C275.914 31.6026 277.147 32.0202 278.329 32.5332L276.891 35.8344C275.894 35.3988 274.854 35.0478 273.799 34.785ZM278.419 75.4254L276.963 72.1314C277.964 71.6904 278.931 71.1666 279.838 70.5726L281.811 73.5822C280.74 74.286 279.6 74.9052 278.419 75.4254ZM279.771 37.3842L281.733 34.3674C282.811 35.0676 283.837 35.8614 284.786 36.729L282.356 39.3876C281.555 38.6514 280.684 37.9782 279.771 37.3842ZM284.856 71.2116L282.417 68.5638C283.222 67.8222 283.965 67.014 284.631 66.1572L287.472 68.3694C286.685 69.3792 285.805 70.335 284.856 71.2116ZM289.587 65.1348L286.422 63.4194C286.942 62.4582 287.385 61.452 287.734 60.4278L291.142 61.5942C290.724 62.8074 290.202 63.999 289.587 65.1348ZM288.534 57.2598C288.71 56.187 288.8 55.089 288.8 54L291.864 53.9226L292.396 53.9298C292.4 55.287 292.294 56.5812 292.083 57.8466L288.534 57.2598Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M263.995 43.3525H276.224V46.1745H263.995V43.3525ZM261.173 48.0558H276.224V50.8777H261.173V48.0558Z",
    fill: "#00B0A6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M265.351 56.5216H265.406C268.812 56.5216 272.461 53.8755 272.461 49.9371C272.461 45.9986 268.812 43.3525 265.406 43.3525H261.173V46.1745H265.406C267.181 46.1745 269.639 47.4829 269.639 49.9371C269.639 52.3912 267.181 53.6996 265.406 53.6996H261.173V56.7125L271.105 64.9874H275.511L265.351 56.5216Z",
    fill: "#00B0A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.499 193.574L247.191 206L360 206V173.5L312.5 146L227.499 193.574Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step_5.509c0f16c17869edd970eb0dc394ed49.svg";
export { ForwardRef as ReactComponent };